const mutations = {
    identidyResultMutation(state, value) {
        state.openResult = { ...state.openResult, ...value };
    },
};

export default mutations;